import { useState } from 'react'

export const PersonalizationState = () => {
    const [welcome, setWelcome] = useState({start: false, features: false})
    const [openP, setOpenP] = useState(false)
    const [tour, setTour] = useState(false)
    const [step, setStep] = useState(1)
    const [booking, setBooking] = useState({welcome: false, tour: false})
    const [show, setShow] = useState({welcome: false, tour: false})
    return {
        welcome: {data: welcome, set: setWelcome},
        openP: {data:openP, set: setOpenP},
        tour: {data: tour, set: setTour},
        step: {data: step, set: setStep},
        booking: {data: booking, set: setBooking},
        show: {data: show, set: setShow},
    }
}
